<div class="approval-page">
  <mat-card class="approval-card">
    <mat-card-title>Account Link Approval</mat-card-title>

    <mat-card-content>
      <div class="status-row" *ngIf="state === 'loading' || state === 'approving'">
        <mat-spinner diameter="36" strokeWidth="4"></mat-spinner>
        <span>{{ state === 'loading' ? 'Validating approval link...' : 'Processing approval...' }}</span>
      </div>

      <div class="status-row" *ngIf="state === 'denying'">
        <mat-spinner diameter="36" strokeWidth="4"></mat-spinner>
        <span>Processing denial...</span>
      </div>

      <div class="status-row success" *ngIf="state === 'approved' || state === 'alreadyApproved'">
        <mat-icon>check_circle</mat-icon>
        <span>{{ detailMessage }}</span>
      </div>

      <div class="status-row warning" *ngIf="state === 'denied' || state === 'alreadyDenied'">
        <mat-icon>block</mat-icon>
        <span>{{ detailMessage }}</span>
      </div>

      <div class="status-row warning" *ngIf="state === 'expired' || state === 'used' || state === 'revoked'">
        <mat-icon>warning</mat-icon>
        <span>{{ detailMessage }}</span>
      </div>

      <div class="status-row error" *ngIf="state === 'invalid' || state === 'error'">
        <mat-icon>error_outline</mat-icon>
        <span>{{ detailMessage }}</span>
      </div>

      <div class="status-row ready" *ngIf="state === 'ready'">
        <mat-icon>how_to_reg</mat-icon>
        <span>{{ detailMessage }}</span>
      </div>

      <div class="request-context" *ngIf="individualName || entityName || requestedUserEmail">
        <div *ngIf="individualName">
          <strong>Individual:</strong>
          <span>{{ individualName }}</span>
        </div>
        <div *ngIf="showEntityContextRow">
          <strong>{{ (entityType || requestType || 'Entity') + ':' }}</strong>
          <span>{{ entityName }}</span>
        </div>
        <div *ngIf="requestedUserEmail">
          <strong>User:</strong>
          <span>{{ requestedUserEmail }}</span>
        </div>
      </div>

      <div class="decision-context" *ngIf="finalDecision">
        <div>
          <strong>Final Decision:</strong>
          <span>{{ finalDecisionLabel }}</span>
        </div>
        <div *ngIf="finalDecisionByEmail">
          <strong>Processed By:</strong>
          <span>{{ finalDecisionByEmail }}</span>
        </div>
        <div *ngIf="finalDecisionAt">
          <strong>Processed On:</strong>
          <span>{{ finalDecisionAt | date:'MM/dd/yyyy h:mm a' }}</span>
        </div>
      </div>
    </mat-card-content>

    <mat-card-actions>
      <button mat-raised-button color="primary" (click)="approveRequest()" *ngIf="canTakeAction">Approve Request</button>
      <button mat-raised-button color="warn" (click)="denyRequest()" *ngIf="canTakeAction">Deny Request</button>
      <a mat-button [routerLink]="returnRoute">Return</a>
    </mat-card-actions>
  </mat-card>
</div>
